export class PaginationRequest {
  page?: number;
  query?: any;
  sort?: string;
  pageSize?: number;
  fromStartDate?: Date;
  toStartDate?: Date;

  constructor(query?: any, sort = '-startDate', page = 1, pageSize = 20) {
      this.page = page;
      // this.query = query ? query.trim() : null;
      this.query = query ? query : null;
      this.sort = sort ? sort.trim() : null;
      this.pageSize = pageSize;
  }
}
